<template>
  <div v-if="winnersList.length > 0">
    <div v-for="(winner, index) in winnersList" :key="index" class="list_item weekly">
      <div class="winners_list_outer">
        <div class="avatar"> <img :src="winner.userDTO.avatar || 'static/images/avatar_0/Avatar_6_male.png'" alt=""></div>
        <div class="winners_list_info">
          <div class="name">
            <h1>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }} </h1>
          </div>
          <div class="prize_outer">
            <div class="prize_category">
              <h1 v-if="winner.prizeDTO.type === 'WEEKLY'">{{ getTranslations.visitor_visitor_winner_weekly }} </h1>
              <h1 v-if="winner.prizeDTO.type === 'MONTHLY'">{{ getTranslations.visitor_visitor_winner_monthly }} </h1>
              <h1 v-if="winner.prizeDTO.type === 'GRAND'">{{ getTranslations.visitor_visitor_winner_grand }} </h1>
              <h1 v-if="winner.prizeDTO.type === 'DAILY'">{{ getTranslations.visitor_visitor_winner_daily }} </h1>
            </div>
            <div class="prize_inner">
              <div class="prize_info">
                <p>{{ winner.prizeDTO.headline }}</p>
              </div>
              <div class="prize_date">
                <p>{{ normalizeDate(winner.localDateTime) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'visitor-winners',
  props: {
    winnersList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    normalizeDate(date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};

</script>



// WEBPACK FOOTER //
// src/components/visitor/VisitorWinners.vue